import React from 'react'
import { SomethingWentWrong } from '../SomethingWentWrong'

export const PerthNowSomethingWentWrong = () => <SomethingWentWrong attribution />
